import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Autocomplete,
  Box,
  Grid,
  IconButton,
  Paper,
  Table,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Button,
} from "@mui/material";
import { MultiSelect } from "react-multi-select-component";
import React, { useState } from "react";
import { CustomInputField } from "../CommonComponents/CustomCompontes";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import DeleteIcon from "@mui/icons-material/Delete";
import { companyWiseEmp } from "../../actions/Companywiseclient";
import CloseIcon from "@mui/icons-material/Close";

function OrderManagementConfiguration({ userList }) {
  const [selectedUser, setSelectedUser] = React.useState(null);
  console.log(userList, "userListtttt");
  const [userExistingPermission, setUserExistingPermission] = React.useState(
    []
  );
  const [allOrderPermission, setAllOrderPermission] = React.useState([]);
  const [permissionList, setPermissionList] = React.useState([]);

  const [selectedPermission, setSelectedPermission] = React.useState([]);
  const [permissionInputVal, setPermissionInputVal] = React.useState("");

  const getUserExistingPermission = async (userId) => {
    const res = await companyWiseEmp.fetchOrderPermissionsByUser({
      userId: userId,
    });
    if (res && res.responseCode === 200) {
      debugger;
      setUserExistingPermission(res.data);
      const userExistingPermissionStrArr = res.data.map(
        (item) => item.sfaPermissionDTO?.sfaPermissionName
      );
      setPermissionList(
        allOrderPermission.filter(
          (item) =>
            !userExistingPermissionStrArr.includes(item.sfaPermissionName)
        )
      );
    } else {
      setUserExistingPermission([]);
      setPermissionList([]);
    }
  };

  const getAllOrderPermissionList = async () => {
    const res = await companyWiseEmp.fetchAllOrderPermissions();
    if (res && res.responseCode === 200) {
      setAllOrderPermission(res.data);
    } else {
      setAllOrderPermission([]);
    }
  };

  const savePermissionForUser = async () => {
    const response = await companyWiseEmp.fetchSavePermissionForUser({
      userId: selectedUser.id,
      permissionids: selectedPermission.map((item) => item.id),
    });
    if (response && response.responseCode === 200) {
      alert(response.responseDescription);
      setSelectedPermission([]);
      setPermissionInputVal("");
      getUserExistingPermission(selectedUser.id);
    } else {
      alert("Something Went Wrong");
    }
  };

  const handleRemovePermissionForUser = async (permissionDto) => {
    const response = await companyWiseEmp.fetchRemovePermissionForUser({
      // id: permissionDto.id,
      userId: selectedUser.id,
      sfaPermissionId: permissionDto.sfaPermissionId,
    });
    if (response && response.responseCode === 200) {
      alert(response.responseDescription);
      getUserExistingPermission(selectedUser.id);
    } else {
      alert("Something Went Wrong");
    }
  };

  React.useEffect(() => {
    getAllOrderPermissionList();
  }, []);

  React.useEffect(() => {
    if (selectedUser) {
      getUserExistingPermission(selectedUser.id);
    } else {
      setUserExistingPermission([]);
      setPermissionList([]);
    }
  }, [selectedUser]);

  return (
    <div>
      {/* <Grid className="CompanyBox"> */}
      <Accordion className="main_accoardian" defaultExpanded={true}>
        <AccordionSummary
          className="accordianHeader"
          expandIcon={
            <AddCircleIcon fontSize="large" style={{ color: "white" }} />
          }
          aria-controls="panel1a-content"
          style={{
            background: "rgb(10 166 141)",
            borderRadius: "10px 10px 0px 0px",
            overflow: "hidden",
          }}
        >
          <Grid>
            <Grid>
              <h3
                style={{
                  color: "#fff",
                  marginLeft: "10px",
                  padding: "10px 2px",
                }}
              >
                Order Management Configuration:-
              </h3>
            </Grid>
          </Grid>
        </AccordionSummary>
        <AccordionDetails>
          <Box>
            <Grid container spacing={3}>
              <Grid item>
                <div className="field_box">
                  <Autocomplete
                    size="small"
                    className="select_box_forCompanyWise"
                    limitTags={1}
                    id="multiple-limit-tags"
                    options={userList}
                    getOptionLabel={(option) =>
                      `${option.name}(${option.empCode})`
                    }
                    disablePortal={true}
                    fullWidth
                    onChange={(event, newValue) => {
                      setSelectedUser(newValue);
                      setSelectedPermission([]);
                      setPermissionInputVal("");
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="outlined"
                        margin="dense"
                        placeholder="User"
                      />
                    )}
                  />
                </div>
              </Grid>

              <Grid item>
                <div className="field_box">
                  <Autocomplete
                    size="small"
                    multiple
                    className="select_box_forCompanyWise"
                    limitTags={1}
                    id="multiple-limit-tags"
                    options={[
                      { id: 0, sfaPermissionName: "Select All" },
                      ...permissionList,
                    ]}
                    getOptionLabel={(option) => `${option.sfaPermissionName}`}
                    disablePortal={true}
                    fullWidth
                    value={selectedPermission}
                    onChange={(event, newValue) => {
                      if (
                        newValue[newValue.length - 1] &&
                        newValue[newValue.length - 1].id === 0
                      ) {
                        setSelectedPermission(permissionList);
                      } else {
                        setSelectedPermission(newValue);
                      }
                    }}
                    inputValue={permissionInputVal}
                    onInputChange={(event, newVal) => {
                      setPermissionInputVal(newVal);
                    }}
                    isOptionEqualToValue={(option, value) =>
                      option.id === value.id
                    }
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="outlined"
                        margin="dense"
                        placeholder="Order Permissions"
                      />
                    )}
                  />
                </div>
              </Grid>

              {selectedUser && Boolean(selectedPermission.length) && (
                <Grid item>
                  <div className="field_box">
                    <Button
                      className="field_box_btn1"
                      onClick={savePermissionForUser}
                      sx={{
                        cursor: "pointer",
                        color: "#fff",
                        textTransform: "none",
                      }}
                    >
                      Save
                    </Button>
                  </div>
                </Grid>
              )}

              <Grid item xs={12}>
                <Box
                  sx={{
                    display: "flex",
                    flexWrap: "wrap",
                    gap: 2,
                  }}
                >
                  {userExistingPermission.map((item, index) => {
                    return (
                      <Box
                        // key={item.id}
                        key={index}
                        sx={{
                          backgroundColor: "#E0DCD6",
                          p: 1.3,
                          borderRadius: 5,
                        }}
                      >
                        {item.sfaPermissionDTO?.sfaPermissionName}
                        <IconButton
                          sx={{ p: 0.4, color: "crimson" }}
                          onClick={() => handleRemovePermissionForUser(item)}
                        >
                          <CloseIcon />
                        </IconButton>
                      </Box>
                    );
                  })}
                </Box>
              </Grid>
            </Grid>
          </Box>
        </AccordionDetails>
      </Accordion>
      {/* </Grid> */}
    </div>
  );
}

export default OrderManagementConfiguration;
